import { useState } from 'react';
import { useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function AppointTime({ appointModal, setAppointModal, handleShowAppointModal, request }) {
    const dispatch = useDispatch();
    const [time, setTime] = useState('');
    const [instruction, setInstructions] = useState('');

    const handleCloseModal = () => {
        setAppointModal(false);
             
    }

    const APPOINT = async () => {
        let reqId = await Number(request[0].id);
        let clientId = await Number(request[0].client_id);
        dispatch({ 
         type: 'APPOINT_REQUEST', 
         payload: {
         request_id: reqId,
         appointment: time,
         instructions: instruction,
         client_id: clientId
        } });
   
        handleCloseModal();
    
    }

    return (
        <Modal
            size="md"
            show={appointModal}
            onHide={() => handleCloseModal()}
            backdrop="static"
            id="appointModal"
        >
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center">
                    <h1>Set an Appointment</h1>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container className="text-center">
                    Please schedule a time for the warehouse visit:
                    <Form.Control
                        required
                        className="text-center px-5"
                        width={25}
                        type="datetime-local"
                        onChange={(e) => setTime(e.target.value)}
                    >
                    </Form.Control>
                    If there are any special instructions, please add them below:
                    <Form.Control
                        as="textarea"
                        rows="3"
                        onChange={(e) => setInstructions(e.target.value)}
                    >
                    </Form.Control>
                </Container>
            </Modal.Body>
            <Modal.Footer
                className="d-flex justify-content-between"
            >
                <Button
                    onClick={handleCloseModal}
                    variant="secondary"
                >Close</Button><Button
                    onClick={APPOINT}
                >Save</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default AppointTime;